import { getValue } from "../../utils/object.utils";

export const transformClassListTableData = (classList: Array<any>): any[] => {
  const transformDatForTable = classList.map((classData: any): any => {
    return {
      id: getValue(classData, "id"),
      name: getValue(classData, "name"),
    };
  });

  return transformDatForTable;
};
